import { InjectionToken } from "@angular/core";
import { PlatformTypes } from "@app/models";
import { WidgetType } from "clearline-common";
import { Observable } from "rxjs";

export enum AdvancedAccountStatus {
  Pending = "Pending",
  Ready = "Ready",
  Error = "Error"
}

export type AdvancedAccountSetupTarget =
  | { kind: "platform"; platform: PlatformTypes }
  | { kind: "marketingApp"; widgetType: WidgetType };

export interface AdvancedAccountSetupFeature {
  name: string;
  icon?: string;
  iconUrl?: string;
  open: () => void;
}

export interface AdvancedAccountSetupDialogData {
  feature: AdvancedAccountSetupFeature;
  target: AdvancedAccountSetupTarget;
  status: AdvancedAccountStatus;
}

export interface AdvancedAccountSetupStatusProvider {
  getStatus(target: AdvancedAccountSetupTarget): Observable<AdvancedAccountStatus>;
  retry(target: AdvancedAccountSetupTarget): Observable<unknown>;
}

export const ADVANCED_ACCOUNT_SETUP_STATUS_PROVIDER = new InjectionToken<AdvancedAccountSetupStatusProvider>(
  "ADVANCED_ACCOUNT_SETUP_STATUS_PROVIDER"
);

export const ADVANCED_ACCOUNT_STATUS_CHECK_INTERVAL_MS = 10000;
